import { ApolloClient } from '@apollo/client';
import { DocumentNode } from 'graphql';
import { defer, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs';

import { FetchedData } from '../utils/fetchFromKnownOrNetwork';
import { UrlQueryInput, UrlQueryResult } from '../types';

interface ApolloUrlResolver {
    client: ApolloClient<any>;
    urlKey: string;
    query: DocumentNode;
}

/**
 * Try to resolve a url via a GQL request
 */
export function resolveFromNetwork(params: ApolloUrlResolver): Observable<FetchedData> {
    const { query, client, urlKey } = params;
    return defer(() => {
        return client.query<{ urlResolver: UrlQueryResult }, UrlQueryInput>({
            query,
            variables: {
                urlKey,
            },
        });
    }).pipe(
        map((result) => {
            return { data: result.data, urlKey };
        }),
        catchError((e) => {
            console.error('error from gql urlResolver', e);
            return throwError(e);
        }),
    );
}
